import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../components/Layout.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Brand from '../views/Brand.vue'
import Category from '../views/Category.vue'
import UOM from '../views/UOM.vue'
import PaymentTerm from '../views/PaymentTerm.vue'
import VendorType from '../views/VendorType.vue'
import Product from '../views/Product.vue'
import Project from '../views/Project.vue'
import Site from '../views/Site.vue'
import Customer from '../views/Customer.vue'
import Supplier from '../views/Supplier.vue'
import Purchase from '../views/Purchase.vue'
import GrnList from '../views/GrnList.vue'
import Sale from '../views/Sale.vue'
import Payment from '../views/Payment.vue'
import User from '../views/User.vue'
import PurchaseReport from '../views/PurchaseReport.vue'
import ProductList from '../views/ProductList.vue'
import ProjectList from '../views/ProjectList.vue'
import SupplierList from '../views/SupplierList.vue'
import LocationList from '../views/LocationList.vue'
import store from '../store'

const ifAuthenticated = (to, from, next) => {
  if (store.state.user != null) {
    next()
    return
  }
  next('/login')
}

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Layout,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: Home,
        name: 'Dashboard',
        meta: {description: 'Overview of environment'}
      },
      {
        path: '/brand',
        alias: '',
        name: 'Brand',
        component: Brand
      },
      {
        path: '/category',
        alias: '',
        name: 'Category',
        component: Category
      },
      {
        path: '/uom',
        alias: '',
        name: 'UOM',
        component: UOM
      },
      {
        path: '/vendor-types',
        alias: '',
        name: 'VendorType',
        component: VendorType
      },
      {
        path: '/payment-terms',
        alias: '',
        name: 'PaymentTerm',
        component: PaymentTerm
      },
      {
        path: '/product',
        alias: '',
        name: 'Product',
        component: Product
      },
      {
        path: '/project',
        alias: '',
        name: 'Project',
        component: Project
      },
      {
        path: '/site',
        alias: '',
        name: 'Site',
        component: Site
      },
      {
        path: '/customer',
        alias: '',
        name: 'Customer',
        component: Customer
      },
      {
        path: '/supplier',
        alias: '',
        name: 'Supplier',
        component: Supplier
      },
      {
        path: '/purchase',
        alias: '',
        name: 'Purchase',
        component: Purchase
      },
      {
        path: '/grn',
        alias: '',
        name: 'GrnList',
        component: GrnList
      },
      {
        path: '/sale',
        alias: '',
        name: 'Sale',
        component: Sale
      },
      {
        path: '/payment',
        alias: '',
        name: 'Payment',
        component: Payment
      },
      {
        path: '/user',
        alias: '',
        name: 'User',
        component: User
      },
      {
        path: '/purchase-report',
        alias: '',
        name: 'PurchaseReport',
        component: PurchaseReport
      },
      {
        path: '/product-list',
        alias: '',
        name: 'ProductList',
        component: ProductList
      },
      {
        path: '/supplier-list',
        alias: '',
        name: 'SupplierList',
        component: SupplierList
      },
      {
        path: '/project-list',
        alias: '',
        name: 'ProjectList',
        component: ProjectList
      },
      {
        path: '/location-list',
        alias: '',
        name: 'LocationList',
        component: LocationList
      }
      
    ]
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
